[
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "cigToken_",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "phunks721_",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "punksV2_",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "punksV1_721_",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "punksV2LegacyWrapper_",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "punksV2C721Wrapper_",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "delegationRegistry_",
                "type": "address"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "OwnableInvalidOwner",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "OwnableUnauthorizedAccount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReentrancyGuardReentrantCall",
        "type": "error"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "uint256",
                "name": "roundId",
                "type": "uint256"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "account",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "numPhunks721",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "numPunksV2",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "numPunksV1_721",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "cigAmount",
                "type": "uint256"
            }
        ],
        "name": "Claimed",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "funder",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "Funded",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "uint256",
                "name": "roundId",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amountPerToken",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint64",
                "name": "startTime",
                "type": "uint64"
            },
            {
                "indexed": false,
                "internalType": "uint64",
                "name": "endTime",
                "type": "uint64"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "allowPhunks721",
                "type": "bool"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "allowPunksV2",
                "type": "bool"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "allowPunksV1_721",
                "type": "bool"
            }
        ],
        "name": "RoundCreated",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "uint256",
                "name": "roundId",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amountPerToken",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint64",
                "name": "startTime",
                "type": "uint64"
            },
            {
                "indexed": false,
                "internalType": "uint64",
                "name": "endTime",
                "type": "uint64"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "allowPhunks721",
                "type": "bool"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "allowPunksV2",
                "type": "bool"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "allowPunksV1_721",
                "type": "bool"
            }
        ],
        "name": "RoundUpdated",
        "type": "event"
    },
    {
        "inputs": [],
        "name": "cigToken",
        "outputs": [
            {
                "internalType": "contract IERC20",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "roundId",
                "type": "uint256"
            },
            {
                "internalType": "uint256[]",
                "name": "phunkTokenIds",
                "type": "uint256[]"
            },
            {
                "internalType": "uint256[]",
                "name": "punksV2TokenIds",
                "type": "uint256[]"
            },
            {
                "internalType": "uint256[]",
                "name": "punksV1TokenIds",
                "type": "uint256[]"
            }
        ],
        "name": "claim",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "amountPerToken",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint64",
                        "name": "startTime",
                        "type": "uint64"
                    },
                    {
                        "internalType": "uint64",
                        "name": "endTime",
                        "type": "uint64"
                    },
                    {
                        "internalType": "bool",
                        "name": "allowPhunks721",
                        "type": "bool"
                    },
                    {
                        "internalType": "bool",
                        "name": "allowPunksV2",
                        "type": "bool"
                    },
                    {
                        "internalType": "bool",
                        "name": "allowPunksV1_721",
                        "type": "bool"
                    },
                    {
                        "internalType": "bool",
                        "name": "exists",
                        "type": "bool"
                    }
                ],
                "internalType": "struct CigAirdrop.RoundConfig",
                "name": "cfg",
                "type": "tuple"
            }
        ],
        "name": "createRound",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "roundId",
                "type": "uint256"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "delegationRegistry",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "fund",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "nextRoundId",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "phunks721",
        "outputs": [
            {
                "internalType": "contract IERC721",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "phunksTokenClaimed",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "roundId",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            },
            {
                "internalType": "uint256[]",
                "name": "phunkTokenIds",
                "type": "uint256[]"
            },
            {
                "internalType": "uint256[]",
                "name": "punksV2TokenIds",
                "type": "uint256[]"
            },
            {
                "internalType": "uint256[]",
                "name": "punksV1TokenIds",
                "type": "uint256[]"
            }
        ],
        "name": "previewClaim",
        "outputs": [
            {
                "internalType": "uint256[]",
                "name": "phunkTokenAmounts",
                "type": "uint256[]"
            },
            {
                "internalType": "uint256[]",
                "name": "punksV2TokenAmounts",
                "type": "uint256[]"
            },
            {
                "internalType": "uint256[]",
                "name": "punksV1TokenAmounts",
                "type": "uint256[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "punksV1TokenClaimed",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "punksV1_721",
        "outputs": [
            {
                "internalType": "contract IERC721",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "punksV2",
        "outputs": [
            {
                "internalType": "contract ICryptoPunks",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "punksV2C721Wrapper",
        "outputs": [
            {
                "internalType": "contract IERC721",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "punksV2LegacyWrapper",
        "outputs": [
            {
                "internalType": "contract IERC721",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "punksV2TokenClaimed",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "rounds",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "amountPerToken",
                "type": "uint256"
            },
            {
                "internalType": "uint64",
                "name": "startTime",
                "type": "uint64"
            },
            {
                "internalType": "uint64",
                "name": "endTime",
                "type": "uint64"
            },
            {
                "internalType": "bool",
                "name": "allowPhunks721",
                "type": "bool"
            },
            {
                "internalType": "bool",
                "name": "allowPunksV2",
                "type": "bool"
            },
            {
                "internalType": "bool",
                "name": "allowPunksV1_721",
                "type": "bool"
            },
            {
                "internalType": "bool",
                "name": "exists",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "roundId",
                "type": "uint256"
            },
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "amountPerToken",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint64",
                        "name": "startTime",
                        "type": "uint64"
                    },
                    {
                        "internalType": "uint64",
                        "name": "endTime",
                        "type": "uint64"
                    },
                    {
                        "internalType": "bool",
                        "name": "allowPhunks721",
                        "type": "bool"
                    },
                    {
                        "internalType": "bool",
                        "name": "allowPunksV2",
                        "type": "bool"
                    },
                    {
                        "internalType": "bool",
                        "name": "allowPunksV1_721",
                        "type": "bool"
                    },
                    {
                        "internalType": "bool",
                        "name": "exists",
                        "type": "bool"
                    }
                ],
                "internalType": "struct CigAirdrop.RoundConfig",
                "name": "cfg",
                "type": "tuple"
            }
        ],
        "name": "updateRound",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }
]